const config = {
    development: {
        firebaseConfig: {
            apiKey: "AIzaSyDOl7WHJyicEhriaxUkfmB97CnYMSKiHV8",
            authDomain: "societyx-video-dev.firebaseapp.com",
            projectId: "societyx-video-dev",
            storageBucket: "societyx-video-dev.appspot.com",
            messagingSenderId: "1046581296290",
            appId: "1:1046581296290:web:dd9382dfdb0f44c0486bfb"
        }
    },
    production: {
        firebaseConfig: {
            apiKey: "AIzaSyDmP3X4ej6AOO8fhIwtddbyPNCY048TbIY",
            authDomain: "thesocietyx-video.firebaseapp.com",
            projectId: "thesocietyx-video",
            storageBucket: "thesocietyx-video.appspot.com",
            messagingSenderId: "541266136174",
            appId: "1:541266136174:web:3651ff0b36d107985faa7f",
            measurementId: "G-7SLMJLDWX5"
        }
    }
}

export default process.env.NODE_ENV == 'production' ? config.production : config.development;
